module.exports = __webpack_public_path__ + "img/logo-canada.4cd44959.svg";